import dayjs from 'dayjs'
import { Codebook } from '../Codebook'

export type WeekDayId = 1 | 2 | 3 | 4 | 5 | 6 | 7

export class WeekDay extends Codebook<WeekDayId> {
  static readonly MONDAY = new WeekDay(1)
  static readonly TUESDAY = new WeekDay(2)
  static readonly WEDNESDAY = new WeekDay(3)
  static readonly THURSDAY = new WeekDay(4)
  static readonly FRIDAY = new WeekDay(5)
  static readonly SATURDAY = new WeekDay(6)
  static readonly SUNDAY = new WeekDay(7)

  private constructor(id: WeekDayId) {
    super(id)
  }

  name(): string {
    return dayjs().day(this.id).format('dddd')
  }
}
